import React from 'react';
import { StyledCircularProgress, StyledLinearProgress } from './styles';

import type { IKakarikoProgressProps } from './types';

export const KakarikoProgress = (props: IKakarikoProgressProps) => {
  const { color = 'primary', size = 24, type = 'circular' } = props;

  return (
    <>
      {type === 'circular' && (
        <StyledCircularProgress size={size} $color={color} />
      )}
      {type === 'linear' && <StyledLinearProgress size={size} $color={color} />}
    </>
  );
};
